import { useQuery } from "@tanstack/react-query";
import { mimshakDataService } from "../services/mimshakDataService";
import { queryKeys } from "../queries/queryKeys";
import { ReportedPeriod } from "../interfaces/DTO/agent/mimshakGroupBy";
import { mimshakDataPreAdviceService } from "../services/mimshakDataPreAdviceService";

const REFRESH_INTERVAL_MS = 3 * 60 * 60 * 1000; // 3 שעות

// ✅ קריאה לפי user_id בלבד
export const useReportedPeriodsByUser = (user_id: number) => {
  return useQuery<ReportedPeriod[], Error>({
    queryKey: queryKeys.reportedPeriods(user_id),
    queryFn: () => mimshakDataService.getDistinctReportedPeriodsForUser(user_id),
    enabled: !!user_id, // ✅ קריאה תתבצע רק אם יש user_id
    refetchInterval: REFRESH_INTERVAL_MS, // ✅ רענון אוטומטי כל 3 שעות
    staleTime: REFRESH_INTERVAL_MS, // ✅ הנתונים ייחשבו כטריים למשך 3 שעות
    retry: 2, // ✅ נסה מחדש עד פעמיים אם יש שגיאה
  });
};

export const usePreAdviceReportedPeriodsByUser = (user_id: number) => {
  return useQuery<ReportedPeriod[], Error>({
    queryKey: [queryKeys.preAdviceReportedPeriods, user_id], // ✅ KEY נפרד ל- PRE_ADVICE
    queryFn: () =>
      mimshakDataPreAdviceService.getDistinctReportedPeriodsForUser(user_id),
    enabled: !!user_id, // ✅ קריאה רק אם user_id קיים
    refetchInterval: REFRESH_INTERVAL_MS, // ✅ רענון כל 3 שעות
    staleTime: REFRESH_INTERVAL_MS, // ✅ תוקף ל-3 שעות
    retry: 2, // ✅ נסה מחדש פעמיים במקרה של שגיאה
  });
};

// ✅ קריאה batch למספר contacts
export const useReportedPeriodsByMultipleContacts = (contactIds: number[]) => {
  return useQuery<ReportedPeriod[], Error>({
    queryKey: ["reportedPeriods", "batch", contactIds.sort().join(",")],
    queryFn: () => mimshakDataService.getDistinctReportedPeriodsForContacts(contactIds),
    enabled: contactIds.length > 0, // ✅ קריאה רק אם יש contact_ids
    refetchInterval: REFRESH_INTERVAL_MS,
    staleTime: REFRESH_INTERVAL_MS,
    retry: 2,
  });
};

export const usePreAdviceReportedPeriodsByMultipleContacts = (contactIds: number[]) => {
  return useQuery<ReportedPeriod[], Error>({
    queryKey: [queryKeys.preAdviceReportedPeriods, "batch", contactIds.sort().join(",")],
    queryFn: () => mimshakDataPreAdviceService.getDistinctReportedPeriodsForContacts(contactIds),
    enabled: contactIds.length > 0,
    refetchInterval: REFRESH_INTERVAL_MS,
    staleTime: REFRESH_INTERVAL_MS,
    retry: 2,
  });
};
